import React from "react";
import { Tag } from "antd";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { getFormattedAmount, getFormattedPercentage } from "./Utils";
import { Tokens } from "./Tokens";

export const PerformanceTag = (value, isPercentage) => {
    const numeric = Number(value) || 0;
    const isPositive = numeric > 0;
    const isZero = numeric === 0;

    let bg = Tokens.raised;
    let color = Tokens.textSecondary;
    let border = Tokens.hairline;

    if (!isZero) {
        bg = isPositive ? Tokens.positiveBg : Tokens.negativeBg;
        color = isPositive ? Tokens.positive : Tokens.negative;
        border = isPositive ? Tokens.positiveBorder : Tokens.negativeBorder;
    }

    let icon = null;
    if (!isZero) {
        icon = isPositive ? (
            <ArrowUpOutlined style={{ marginLeft: 4 }} />
        ) : (
            <ArrowDownOutlined style={{ marginLeft: 4 }} />
        );
    }

    return (
        <React.Fragment>
            &nbsp;
            <Tag
                style={{
                    marginRight: 0,
                    backgroundColor: bg,
                    color,
                    border: `1px solid ${border}`,
                    borderRadius: Tokens.radiusTag,
                    fontVariantNumeric: "tabular-nums",
                    fontWeight: 500,
                    fontSize: "12px",
                    padding: "1px 8px",
                }}
            >
                {isPercentage && getFormattedPercentage(numeric, 1)}
                {!isPercentage && getFormattedAmount(numeric, true)}
                {icon}
            </Tag>
        </React.Fragment>
    );
};
